// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a5091c09","732":"9aeab17b"}[chunkId] + ".chunk.js";
};